const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .icon-users-updated{fill:#f2f2f2;}.b{fill:#fff;}.c{fill:#008941;}.d{fill:#3f3d56;}.e{fill:#ccc;}.f{fill:#e6e6e6;}.g{fill:#ffb8b8;}.h{fill:#2f2e41;}\n        "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0.031)"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-users-updated",
  d: "M802.66,626.163h-98s-1.987-29.136,9.767-29.467,10.429,12.912,25.163-5.3,32.612-17.217,34.93-6.456-4.47,19.369,7.946,16.72S812.759,605.966,802.66,626.163Z",
  transform: "translate(-360.028 -342.287)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M823.728,614.337A34.53,34.53,0,0,0,788.982,634.9c-.554,1.271,1.32,2.381,1.879,1.1a32.384,32.384,0,0,1,32.867-19.48c1.395.126,1.386-2.051,0-2.176Z",
  transform: "translate(-383.184 -352.442)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M717.037,604.97a35.537,35.537,0,0,1,8.444,26.633c-.137,1.393,2.041,1.383,2.176,0a37.671,37.671,0,0,0-9.082-28.172c-.922-1.058-2.456.487-1.539,1.539Z",
  transform: "translate(-363.384 -349.389)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M784.394,579.18a145.227,145.227,0,0,0-14.875,34.594q-1.464,5.175-2.534,10.45c-.279,1.367,1.819,1.952,2.1.579a142.943,142.943,0,0,1,12.113-35.23q2.365-4.74,5.076-9.294a1.089,1.089,0,0,0-1.879-1.1Z",
  transform: "translate(-377.167 -342.689)"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M817.8,393.787v76.491H610.3a6.508,6.508,0,0,1-6.51-6.51V387.277h207.5a6.509,6.509,0,0,1,6.51,6.512Z",
  transform: "translate(-332.37 -290.146)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M766.136,645.968H230.526a.864.864,0,1,1,0-1.728h535.61a.864.864,0,1,1,0,1.728Z",
  transform: "translate(-229.662 -360.69)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "d",
  width: 1.451,
  height: 104.468,
  transform: "translate(387.854 180.133)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M832.034,462.332H609.315a6.537,6.537,0,0,1-6.529-6.529V362.217a6.537,6.537,0,0,1,6.529-6.529H832.034a6.537,6.537,0,0,1,6.529,6.529V455.8A6.537,6.537,0,0,1,832.034,462.332ZM609.315,357.139a5.084,5.084,0,0,0-5.078,5.078V455.8a5.084,5.084,0,0,0,5.078,5.078H832.034a5.084,5.084,0,0,0,5.078-5.078V362.217a5.084,5.084,0,0,0-5.078-5.078Z",
  transform: "translate(-332.096 -281.473)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M783.272,422.041H651.962a2.176,2.176,0,0,1,0-4.353h131.31a2.176,2.176,0,0,1,0,4.353Z",
  transform: "translate(-344.999 -298.494)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M783.272,447.041H651.962a2.176,2.176,0,0,1,0-4.353h131.31a2.176,2.176,0,0,1,0,4.353Z",
  transform: "translate(-344.999 -305.357)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M783.272,472.041H651.962a2.176,2.176,0,0,1,0-4.353h131.31a2.176,2.176,0,0,1,0,4.353Z",
  transform: "translate(-344.999 -312.221)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "e",
  cx: 23.844,
  cy: 23.844,
  r: 23.844,
  transform: "translate(481.689 50.793)"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M921.889,351.483,909.957,339.55a2.074,2.074,0,0,1,2.932-2.932l8.8,8.8,28.086-32.028a2.073,2.073,0,0,1,3.118,2.734Z",
  transform: "translate(-416.257 -269.668)"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M374.281,329.279s14.693-9.28,28.613,1.547l9.28,96.667s-34.8,27.067-43.307,1.547Z",
  transform: "translate(-267.878 -273.207)"
}), /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M137.236,367.18h-8.894L125.38,333l11.858-.125Z",
  transform: "translate(-34.421 -91.392)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M116.619,376.658h17.153v10.8H105.819A10.8,10.8,0,0,1,116.619,376.658Z",
  transform: "translate(-29.051 -103.412)"
}), /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M186.036,367.18h8.894l4.231-34.306H186.035Z",
  transform: "translate(-51.072 -91.392)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M0,0H27.953V10.8H10.8A10.8,10.8,0,0,1,0,0H0Z",
  transform: "translate(161.01 284.046) rotate(179.997)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M344.884,463.066l7.733,115.227,11.987-.387,15.853-92.413,14.693,91.253,13.92.773,3.867-119.094S354.164,445.28,344.884,463.066Z",
  transform: "translate(-261.294 -308.394)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "g",
  cx: 17.818,
  cy: 17.818,
  r: 17.818,
  transform: "translate(102.263 10.654)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M369.168,325.883l-4.64,3.093s-19.333,0-20.88,11.6-5.8,90.867-1.16,90.867,5.413-6.187,5.413-6.187,3.093.773,9.28,6.96,10.053,6.187,12.373-3.093,17.787-80.427,3.093-93.573Z",
  transform: "translate(-260.058 -273.291)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M407.289,325.883l4.64,3.093s19.333,0,20.88,11.6,5.8,90.867,1.16,90.867-5.413-6.187-5.413-6.187-3.093.773-9.28,6.96-10.053,6.187-12.373-3.093-17.787-80.427-3.093-93.573Z",
  transform: "translate(-275.752 -273.291)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M372.281,292.715a9.7,9.7,0,0,1,7.36-16.37c2.464.082,4.786,1.091,7.137,1.831a23.6,23.6,0,0,0,11.089,1,14.807,14.807,0,0,0,9.443-5.576,10.851,10.851,0,0,0,1.335-10.641c-1.8-3.935-6-6.1-9.949-7.864a18.183,18.183,0,0,0-5.051-1.66,6.478,6.478,0,0,0-5.025,1.267c-1.11.955-1.761,2.39-2.969,3.218-1.36.932-3.127.907-4.767,1.071a18.285,18.285,0,0,0-8.856,33.038",
  transform: "translate(-266.657 -253.378)"
}), /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M453.917,470.8a7.793,7.793,0,0,0-.636-11.933l-.21-20.449-10.7,2.03-.4,20.376a7.836,7.836,0,0,0,11.944,9.976Z",
  transform: "translate(-287.599 -304.185)"
}), /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M350.917,465.8a7.793,7.793,0,0,0-.636-11.933l-.21-20.449-10.7,2.03-.4,20.376a7.836,7.836,0,0,0,11.944,9.976Z",
  transform: "translate(-259.322 -302.813)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M441.032,344.538l2.782,1.763s11.452,43.858,11.524,73.637c0,0-15.08,7.347-17.4,1.933S441.032,344.538,441.032,344.538Z",
  transform: "translate(-286.682 -278.412)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M344.636,344.538l-2.782,1.763s-9.966,43.858-7.271,73.251c0,0,15.853,7.347,18.173,1.933S344.636,344.538,344.636,344.538Z",
  transform: "translate(-258.339 -278.412)"
}));
function SvgIconusersUpdated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 537.338,
    height: 285.309,
    viewBox: "0 0 537.338 285.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconusersUpdated);
export default __webpack_public_path__ + "static/media/Icon users-updated.114e519c.svg";
export { ForwardRef as ReactComponent };